// extracted by mini-css-extract-plugin
export var box = "_5x-1";
export var checked = "_5x-2";
export var descriptionSpacer = "_5x-9";
export var disabled = "_5x-3";
export var icon = "_5x-6";
export var input = "_5x-0";
export var labelSpacer = "_5x-8";
export var medium = "_5x-5";
export var small = "_5x-4";
export var text = "_5x-7";